import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { useToaster } from 'src/utils/toaster/toasterContext';

const PinterestCreateBoard = ({ handleClose, profileId, NewBoardCreationCallback }) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [nameError, setNameError] = useState('');
  const [descError, setDescError] = useState('');
  const { showToast } = useToaster();

  const successCallback = (data, message) => {
    setLoadingOn(false);
    NewBoardCreationCallback(data);
    handleClose();
  };

  const failureCallback = (message) => {
    setLoadingOn(false);
    showToast(message, 'e');
  };

  const createBoard = () => {
    setLoadingOn(true);
    const formBody = {
      connected_profile_id: String(profileId),
      name: name,
      description: description,
    };
    const postProps = {
      url: integrateModuleURL.CreateBoard,
      body: formBody,
      successCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setName(value);
      setNameError('');
    } else {
      setNameError(`${translate('post_conditions.name_cannot_exceeds', 'Name cannot exceed')} 50 ${translate('post_conditions.characters', 'characters')}`);
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescription(value);
      setDescError('');
    } else {
      setDescError(
        `${translate('post_conditions.description_cannot_exceeds', 'Description cannot exceed')} 50 ${translate('post_conditions.characters', 'characters')}`
      );
    }
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">{translate('post_conditions.create_pinterest_boards', 'Create Pinterest Board')}</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>{translate('post_conditions.provide_board_details', 'Provide board details')}:</Typography>
        <TextField
          placeholder={translate('post_conditions.board_name', 'Board Name')}
          value={name}
          onChange={handleNameChange}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
          helperText={nameError}
          error={!!nameError}
        />
        <TextField
          placeholder={translate('post_conditions.description', 'Description')}
          value={description}
          onChange={handleDescriptionChange}
          style={{ width: '100%', padding: '8px' }}
          helperText={descError}
          error={!!descError}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close', 'Close')}
        </Button>
        <LoadingButton variant="contained" loading={isLoadingOn} onClick={createBoard} disabled={!name}>
          {translate('post_conditions.create_board', 'Create Board')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PinterestCreateBoard;
